import { memo, useMemo, type FC } from "react";
import {
  LOCATION_FIELDS,
  LOCATION_OPERATORS,
  type LocationCondition,
  type LocationField,
  type LocationOperator,
} from "../../CreateSegment.Constants";
import { LOCATION_OPTIONS_MOCK } from "../../CreateSegment.Mocks";
import { useSegmentLabel, useSegmentOptions } from "../../UseSegmentLabel";
import { ConditionFieldsRow, SegmentSelect, type ConditionFieldsProps } from "../ConditionControls";

const LocationConditionFields: FC<ConditionFieldsProps<LocationCondition>> = ({
  condition,
  onChange,
}) => {
  const label = useSegmentLabel();
  const fieldOptions = useSegmentOptions("fields.location.fields", LOCATION_FIELDS);
  const operatorOptions = useSegmentOptions("fields.location.operators", LOCATION_OPERATORS);
  const valueOptions = useMemo(
    () => LOCATION_OPTIONS_MOCK[condition.field].map(value => ({ value, label: value })),
    [condition.field]
  );

  return (
    <ConditionFieldsRow label={label("fields.location.label")}>
      <SegmentSelect
        className="segment-builder__control--md"
        aria-label={label("fields.location.fieldAria")}
        value={condition.field}
        options={fieldOptions}
        onChange={(field: LocationField) => onChange({ ...condition, field, values: [] })}
      />
      <SegmentSelect
        className="segment-builder__control--lg"
        aria-label={label("fields.location.operatorAria")}
        value={condition.operator}
        options={operatorOptions}
        onChange={(operator: LocationOperator) => onChange({ ...condition, operator })}
      />
      <SegmentSelect
        className="segment-builder__control--grow segment-builder__tags-select"
        aria-label={label("fields.location.valuesAria")}
        mode="multiple"
        maxTagCount="responsive"
        value={condition.values}
        placeholder={label("fields.location.placeholder")}
        options={valueOptions}
        onChange={(values: string[]) => onChange({ ...condition, values })}
      />
    </ConditionFieldsRow>
  );
};

export default memo(LocationConditionFields);
